import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import API from "../lib/api";
import { Section } from "../components/Common";

export default function ArticleDetailPage() {
  const { slug } = useParams();
  const { t } = useTranslation();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get(`/content/articles/${slug}`).then(({ data }) => setArticle(data)).catch(() => setArticle(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="app-container py-20 text-white/70" data-testid="article-loading">{t("article.loading")}</div>;
  if (!article) return <div className="app-container py-20" data-testid="article-not-found">{t("article.not_found")}</div>;

  return (
    <article data-testid="page-article">
      <div className="relative h-[40vh] md:h-[55vh] overflow-hidden">
        <img src={article.image} alt={article.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div className="absolute bottom-0 inset-x-0 app-container pb-8">
          <Link to="/hub" className="btn-ghost inline-flex items-center gap-2 text-sm mb-4" data-testid="article-back-to-hub"><ArrowLeft className="w-4 h-4" /> {t("article.hub_back")}</Link>
          <div className="text-xs tracking-[0.32em] uppercase gold-text mb-2">{article.category?.replace(/-/g, " ")}</div>
          <h1 className="font-display text-3xl md:text-5xl max-w-3xl leading-tight">{article.title}</h1>
          <div className="text-sm text-white/70 mt-3">{t("article.min_read", { n: article.read_time })} · {article.author}</div>
        </div>
      </div>
      <Section>
        <div className="max-w-3xl mx-auto">
          <p className="text-white/85 text-lg leading-relaxed">{article.summary}</p>
          <div className="gold-divider my-8" />
          {(article.body || []).map((p, i) => (
            <p key={i} className="text-white/85 leading-relaxed mb-5">{p}</p>
          ))}
          <div className="mt-8 flex flex-wrap gap-2">
            {(article.tags || []).map((tg) => <span key={tg} className="chip">#{tg}</span>)}
          </div>
        </div>
      </Section>
    </article>
  );
}
